<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6" v-for="(accounts) in usersAccounts" v-bind:key="accounts.id" >
        <balance-card type="success"
                    icon="ti-wallet"
                    small-title="Balance"
                    :title="accounts.balance">
          <div class="stats" slot="footer">
            <i class='nc-icon nc-calendar-60'></i>
            {{accounts.name}}: {{accounts.number}}
            <router-link :to="{ name: 'Sync Account', params: { id: accounts.id }}">
              <button type="button" class="btn btn-warning btn-sm">
                re-sync
              </button>
            </router-link>
          </div>
        </balance-card>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6" >
        <router-link :to="{ name: 'Link Account'}" style="text-decoration: none;">
          <balance-card type="success"
                      icon="ti-plus"
                      small-title=""
                      title="Add account">
            <div  slot="footer">&nbsp;</div>
          </balance-card>
        </router-link>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="card">
          <div class="card-header text-center">
            <h5 class="card-title">Goals</h5>
            <p class="card-category">Ongoing</p>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12" v-for="(key, index) in usersGoals.slice(0, 5)"  v-bind:key="index">
                {{ key.description }}
                <p-progress :value="Number ((key.saved/key.amount) * 100)"  
                  type="danger" :stroke-width="25"></p-progress>
                <br>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-lg-12">
                <router-link :to="{ name: 'Goals'}" v-if="usersGoals.length > 0">
                  <p-button type="primary" round>
                    View All
                  </p-button>
                </router-link>
                <router-link :to="{ name: 'Add Goal' }" v-if="usersGoals.length == 0">
                  <p-button type="primary" round>
                    Add Goal
                  </p-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-sm-12">
        <div class="card">
          <div class="card-header text-center">
            <h5 class="card-title">Budget</h5>
            <p class="card-category">Assigned</p>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12" v-for="(key, index) in usersBudget.slice(0,5)"  v-bind:key="index">
                {{ key.category }}
                <p-progress :value="Number ((usersTransactions[key.category]/key.amount) * 100)"  
                  type="danger" :stroke-width="25"></p-progress>
                <br>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-lg-12">
                <router-link :to="{ name: 'Budget'}" v-if="usersBudget.length > 0">
                  <p-button type="primary" round>
                    View All
                  </p-button>
                </router-link>
                <router-link :to="{ name: 'Add Budget'}" v-if="usersBudget.length == 0">
                  <p-button type="primary" round>
                    Add Budget
                  </p-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import BalanceCard from 'src/components/UIComponents/Cards/BalanceCard';
  

  export default {
    components: {
      BalanceCard,
      
      PProgress,
      Card
    },
    
    data () {
      return {
        usersBudget: [],
        usersTransactions: [],
        usersGoals: [],
        usersAccounts: [],
        isNotShown: true,
        shownAccountText: 'Show all accounts'
      }
    },

    methods: {
      getBudget () {
        this.$http.get('/budgets')
        .then(response => {
          let budgetData = response.data
        
          let userBudgeted = []

          for (let key = 0; key < budgetData.length; key++) {

            let budgeted = new Object
            budgeted.category = budgetData[key]['name']
            budgeted.amount = isNaN(budgetData[key]['amount']) ?  0 : budgetData[key]['amount']
            
            userBudgeted[key] = budgeted

          }

          this.usersBudget = userBudgeted
          
        })
        .catch(error => {
          
        })
      },

      getTransactions () {
        this.$http.get ('/transactions')

        .then(response => {

          let transactionData = response.data
          let transactionClassifications = []
          let totalByCategory = [] 

          for (let key = 0; key < transactionData.length; key++) {

            let transactionClassification = transactionData[key]['name']
             
            if(!transactionClassifications.includes(transactionData[key]['name'])) {

              transactionClassifications.push(transactionData[key]['name'])

              if(transactionData[key]['type_id'] == 2) {

                totalByCategory[transactionData[key]['name']] 
                = isNaN(transactionData[key]['amount']) ? 0 : transactionData[key]['amount']
          
              }
            
            }else{

              if(transactionData[key]['type_id'] == 2) {

                totalByCategory[transactionData[key]['name']] 
                = totalByCategory[transactionData[key]['name']] + isNaN(transactionData[key]['amount']) ? 0 : transactionData[key]['amount']
              }
            }
          }

          this.usersTransactions = totalByCategory

        })
        .catch(err => console.error(err))
      },

      getGoals () {
        this.$http.get('/goals')
        .then(response => {
          this.usersGoals = response.data
        })
        .catch(err => console.error(err));
		  },

      getAccounts () {
        this.$http.get('/accounts')
        .then(response => {
          
          for (let key = 0; key < response.data.length; key++) {

            if (response.data[key]['currency'] == 'NGN') {
              response.data[key]['balance'] =
              new Intl.NumberFormat('en-US', 
                { style: 'currency', currency: 'NGN' }).format(response.data[key]['balance'] / 100).replace('NGN', '₦')
            }
            
            response.data[key]['name'] = response.data[key]['name'].replace('First City Monument Bank', 'FCMB')
            response.data[key]['name'] = response.data[key]['name'].replace('Guaranty Trust Bank', 'GTB')
            response.data[key]['name'] = response.data[key]['name'].replace('VFD Microfinance Bank Limited', 'VFD')
            
            response.data[key]['name'] = response.data[key]['name'].replace('United Bank For Africa', 'UBA')
            response.data[key]['name'] = response.data[key]['name'].replace('Microfinance Bank', 'MFB')

            if (response.data[key]['name'].substring(response.data[key]['name'].length - 5) == ' Bank') {
              response.data[key]['name']= response.data[key]['name'].replace(' Bank', '')
            }
          }
          
          this.usersAccounts = response.data
        })
        .catch(err => console.error(err));
		  },

      showingAccounts () {
        this.isNotShown = !this.isNotShown

        if (!this.isNotShown) {
          this.shownAccountText= 'Show less'
        }else{
          this.shownAccountText= 'Show all accounts'
        }
        
        
      }
    },

    beforeMount () {
      this.getGoals (),
      this.getBudget (),
      this.getTransactions (), 
      this.getAccounts ()
      
    }
  }

</script>
<style>
  .notShown {display: none}
  .stats {font-size: 11px;}
  .btn-sm {
    font-size: 0.8571em;
    border-radius: 3px;
    padding: 3px 5px;
    float: right !important;
}
</style>
